module.exports = __webpack_public_path__ + "static/vmware_11.e7853920.jpg";